import React, { useEffect, useState } from "react";
import { TextField, InputAdornment } from "@mui/material";
import classes from "./MyInput.module.css";
const MyInput = ({
  label,
  value,
  name,
  setter,
  error,
  leftIcon,
  leftIconHandler,
  className,
  type = "text",
  disabled,
  readOnly = false,
  multiline = false,
  maxRows = 3,
  minRows = 1,
  ...props
}) => {
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowSize(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  let inputType = type;
  let regexType = "text";
  if (inputType === "number") {
    regexType = "number";
    inputType = "string";
  }


  const handleInputChange = (e) => {
    setter(e);
    // const inputValue = e.target.value;
    // if (regexType === "number") {
    //   setter(Number(inputValue.replace(/[^\d]/g, ""))); // Replace non-numeric characters
    // } else {
    //   setter(inputValue);
    // }
  };



  return (
    <>
      <TextField
        id="outlined-basic"
        type={inputType}
        name={name}
        label={label}
        value={value}
        onChange={handleInputChange}
        variant="outlined"
        multiline={multiline}
        maxRows={maxRows}
        minRows={minRows}
        // size={windowSize > 1024 ? "medium" : "small"}
        className={[
          "custom-textfield w-100",
          classes["input-wrapper"],
          readOnly && classes["readOnly"],
          className,
        ].join(" ")}
        InputProps={{
          endAdornment: leftIcon && (
            <InputAdornment position="end" onClick={leftIconHandler}>
              {leftIcon}
            </InputAdornment>
          ),

        }}
        disabled={disabled}
        readOnly={readOnly}
        InputLabelProps={{ shrink: (value || value === 0) ? true : false }}
        {...props}
      />
      {error && (
        <span
          style={{
            display: "inline-block",
            color: "red",
            fontSize: "14px",
            // marginBottom: "5px",
          }}
        >
          {error}
        </span>
      )}
    </>
  );
};

export default MyInput;
